import React, { useEffect, useState } from 'react';
import { HStack } from '@chakra-ui/react';
import {
  setGlobalDate,
  setGlobalPeriod,
  useAppDispatch,
  useAppSelector,
} from '@spartalabs/pdc-core';
import DateRangeComp from 'components/Calendar';
import SegmentedPicker from 'components/SegmentedPicker';
import { useDateSelect } from 'hooks/useDateSelect';
import { useSegmentedPicker } from 'hooks/useSegmentedPicker';
import {
  isHeaderDateSelectShown,
  isSidebarDateFilterShown,
} from 'utils/functions';

interface DateFilterProps {
  path: string;
  /** Drawer "Filtrar" usa regras mais amplas (ex.: Serviços e Chamados). */
  placement?: 'header' | 'sidebar';
}

export const DateFilter: React.FC<DateFilterProps> = ({
  path,
  placement = 'header',
}) => {
  const dispatch = useAppDispatch();

  const { globalDate } = useAppSelector(state => state.globalDataSlicer);

  const [pickedPeriod, setPickedPeriod] = useState('Mês');
  const { onSegmentedPickerChange } = useSegmentedPicker(setPickedPeriod);

  const [dateRange, setDateRange] = useState<DateProps[]>(globalDate);

  const { onDateRangeChange } = useDateSelect(setDateRange);

  const isVisible =
    placement === 'sidebar'
      ? isSidebarDateFilterShown(path)
      : isHeaderDateSelectShown(path);

  useEffect(() => {
    if (!isVisible) return;

    dispatch(setGlobalPeriod(pickedPeriod));
    dispatch(setGlobalDate(dateRange));
  }, [dateRange, dispatch, isVisible, pickedPeriod]);

  useEffect(() => {
    if (dateRange !== globalDate) setDateRange(globalDate);
  }, [globalDate]);

  const stackDisplay =
    placement === 'sidebar'
      ? isVisible
        ? 'flex'
        : 'none'
      : { xs: isVisible ? 'flex' : 'none', base: 'none' };

  return (
    <HStack
      spacing={6}
      display={stackDisplay}
      justify="center"
      mb="26px"
      flexWrap="wrap"
    >
      <DateRangeComp
        dateName="header"
        display={isVisible ? 'flex' : 'none'}
        type={pickedPeriod}
        startDate={dateRange}
        ref={onDateRangeChange}
        isOnHeader
      />
      <SegmentedPicker
        pickerName="header"
        display={isVisible ? 'flex' : 'none'}
        firstSelectedLabel={pickedPeriod}
        ref={onSegmentedPickerChange}
        labels={['Dia', 'Mês']}
      />
    </HStack>
  );
};
